import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import { resetCart } from "../../../redux/slices/cartSlice";
import { API_BASE_URL } from "../../../config/config";
import "./Response.css";

function Response() {
  const [isPrintMessage, setIsPrintMessage] = useState(false);
  const dispatch = useDispatch();
  const currentUrl = window.location.href;

  function getQueryParam(url, param) {
    const queryParams = new URLSearchParams(url.split("?")[1]);
    return queryParams.get(param);
  }

  const message = getQueryParam(currentUrl, "message");

  // Record coupon usage after successful payment
  async function recordCouponUsage() {
    const pendingCouponId = localStorage.getItem("pendingCouponId");
    const pendingOrderId = localStorage.getItem("pendingOrderId");

    if (pendingCouponId && pendingCouponId !== "") {
      try {
        await axios.post(
          `${API_BASE_URL}/api/CouponCodeApi/recordUsage`,
          {
            couponCodeId: pendingCouponId,
            orderId: pendingOrderId || "",
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Coupon usage recorded successfully");
      } catch (error) {
        console.error("Failed to record coupon usage:", error);
      }
    }

    // Clear pending coupon data
    localStorage.removeItem("pendingCouponId");
    localStorage.removeItem("pendingOrderId");
  }

  useEffect(() => {
    if (message === "SUCCESS") {
      setIsPrintMessage(true);

      // Record coupon usage after successful payment
      recordCouponUsage();

      // Clear the cart after successful payment
      dispatch(resetCart());
    }
  }, [currentUrl, dispatch]);

  return (
    <div className="transaction-container">
      <div className="transaction-header">
        {isPrintMessage && (
          <div>
            <h3>Transaction Successfully</h3>
            <p>Our Team Will Contact You Soon</p>
          </div>
        )}
      </div>
      <center>
        <Link to={"/cart"}>
          <div className="transaction-footer">
            <button
              className="btn-back"
              style={{ zoom: "80%", backgroundColor: "red" }}
            >
              Back to Cart
            </button>
          </div>
        </Link>
      </center>
    </div>
  );
}

export default Response;
